// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"22eeb601","232":"adeacf80","237":"c02c9337","526":"c931bade"}[chunkId] + ".chunk.js";
};